module.exports = __webpack_public_path__ + "assets/89a2596562f1a19b4716cb6f7fee6293.eot";